<div class="p-3">
  <div class="flex flex-column gap-3">
    <div class="field">
      <label for="service-identifier" class="font-semibold block mb-2">Service identifier *</label>
      <p-dropdown
        id="service-identifier"
        [options]="sites"
        optionLabel="site"
        optionValue="site"
        [filter]="true"
        filterBy="site"
        placeholder="Select a site"
        [(ngModel)]="location"
        class="w-full"
      ></p-dropdown>
    </div>

    <div class="field">
      <label for="product-code" class="font-semibold block mb-2">Product Code *</label>
      <p-dropdown
        id="product-code"
        [options]="products"
        optionLabel="code"
        [filter]="true"
        filterBy="code,description"
        placeholder="Select a product"
        [(ngModel)]="selectedProduct"
        (onChange)="onProductChange($event.value)"
        class="w-full"
      >
        <ng-template let-product pTemplate="item">
          <div class="flex flex-column">
            <span class="font-medium">{{ product.code }}</span>
            <small class="text-600">{{ product.description }}</small>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div class="field">
      <label for="product-description" class="font-semibold block mb-2">Description</label>
      <input
        id="product-description"
        type="text"
        pInputText
        [(ngModel)]="description"
        class="w-full"
        placeholder="Description (auto-filled from selected code)"
        [readonly]="!!selectedProduct"
      />
    </div>

    <div class="formgrid grid">
      <div class="field col-6">
        <label for="product-quantity" class="font-semibold">Quantity *</label>
        <input
          id="product-quantity"
          type="number"
          pInputText
          [(ngModel)]="quantity"
          [min]="1"
          class="w-full"
          placeholder="Enter quantity"
        />
      </div>
      <div class="field col-6">
        <label for="product-rate" class="font-semibold">Rate (Optional)</label>
        <input
          id="product-rate"
          type="number"
          pInputText
          [ngModel]="rate"
          (ngModelChange)="onRateChange($event)"
          [min]="0"
          step="0.01"
          class="w-full"
          [placeholder]="catalogRate ? 'Rate: ' + formatCurrency(catalogRate) : 'Enter rate'"
        />
        <small class="text-600" *ngIf="catalogRate !== undefined && catalogRate !== null">
          Catalog rate: {{ formatCurrency(catalogRate) }} (you can edit)
        </small>
      </div>
    </div>

    <div class="field">
      <label for="product-effective-date" class="font-semibold block mb-2">Effective Date (Optional)</label>
      <p-calendar
        id="product-effective-date"
        [(ngModel)]="effectiveDate"
        [showIcon]="true"
        dateFormat="yy-mm-dd"
        [showButtonBar]="true"
        [showTime]="false"
        placeholder="Select effective date (defaults to today)"
        [appendTo]="'body'"
        [baseZIndex]="10000"
        [panelStyleClass]="'product-form-calendar-panel'"
        styleClass="w-full"
      ></p-calendar>
      <small class="text-600">
        Date when this change will take effect in the billing cycle. If not set,
        it will default to today.
      </small>
    </div>
  </div>
</div>

<div class="p-dialog-footer">
  <button
    pButton
    type="button"
    label="Cancel"
    icon="pi pi-times"
    class="p-button-text"
    (click)="cancel()"
  ></button>
  <button
    pButton
    type="button"
    label="Add"
    icon="pi pi-plus"
    class="p-button-success"
    [disabled]="!location || !selectedProduct || !quantity || quantity < 1"
    (click)="save()"
  ></button>
</div>
